import { SettingExamRoutes, SettingMessageTemplateRoutes, SettingOrderRoutes, SettingPatientRoutes, SettingContactRoutes, SettingCalendarRoutes, SettingInsuranceRoutes, SettingApiKeysRoutes, SettingAuthenticationRoutes } from '../../itrust_common/routes/authorised/setting/index';
import DashboardRoutes from './dashboardRoutes.js';
import AppointmentRoutes from './appointmentRoutes.js';
import PatientRoutes from './patientRoutes.js';
import ExamRoutes from './examRoutes';
import OrderRoutes from './orderRoutes.js';
import PaymentReportRoutes from './paymentReportRoutes';
import CampaignRoutes from './campaignRoutes';
import LogsRoutes from './logsRoutes';
import ReportsRoutes from './reportsRoutes.js';
import OrganisationStoreRoutes from './organisationStoreRoutes.js';
import AnalyticsRoutes from './analyticsRoutes';
import ActivityRoutes from '../../itrust_common/routes/authorised/activityRoutes';
import OrganisationRoutes from './organisationRoutes.js';
import AddOnsRoutes from './addOns/index.js';

export default function RoutesRender(props) {
  const { currentUserRole } = props

  return (
    <>
      <AddOnsRoutes />
      {DashboardRoutes}
      {AppointmentRoutes}
      {ActivityRoutes}
      {PatientRoutes}
      {ExamRoutes}
      {ReportsRoutes}
      {OrderRoutes}
      {CampaignRoutes}
      {LogsRoutes}
      {AnalyticsRoutes}
      {PaymentReportRoutes}
      {["super_admin", "admin", "itrust_admin"].includes(currentUserRole) &&
        [
          OrganisationRoutes,
          OrganisationStoreRoutes,
          SettingExamRoutes,
          SettingMessageTemplateRoutes,
          SettingOrderRoutes,
          SettingPatientRoutes,
          SettingCalendarRoutes,
          SettingContactRoutes,
          SettingInsuranceRoutes,
          SettingApiKeysRoutes,
          SettingAuthenticationRoutes
        ]
      }
    </>
  )
}